/**
 * Google Maps JavaScript API loader — a thin wrapper around the Maps JS
 * `<script>` tag (`v=weekly` + `callback`). No npm dependency; the SDK is
 * fetched from `maps.googleapis.com` at runtime using the REFERRER-RESTRICTED
 * client key only (never a server API key). The key is absent in dev by
 * default, in which case callers should render the SVG fallback instead of
 * calling this loader.
 */
const CALLBACK_NAME = '__cwosMapsReady';
const SCRIPT_BASE = 'https://maps.googleapis.com/maps/api/js';
let pendingKey = null;
let pendingPromise = null;
/** Load the Maps JS API exactly once per key. Resolves when `google.maps` is ready. */
export function loadGoogleMaps(key) {
    if (typeof window === 'undefined') {
        return Promise.reject(new Error('Google Maps requires a browser environment'));
    }
    if (typeof google !== 'undefined' && google.maps) {
        return Promise.resolve();
    }
    if (pendingPromise && pendingKey === key) {
        return pendingPromise;
    }
    pendingKey = key;
    pendingPromise = new Promise((resolve, reject) => {
        const previous = window[CALLBACK_NAME];
        window[CALLBACK_NAME] = () => {
            try {
                previous?.();
            }
            catch {
                // A prior callback should never break our own resolve.
            }
            resolve();
        };
        const script = document.createElement('script');
        script.async = true;
        script.defer = true;
        script.src = `${SCRIPT_BASE}?v=weekly&key=${encodeURIComponent(key)}&callback=${CALLBACK_NAME}`;
        script.onerror = () => {
            if (window[CALLBACK_NAME])
                delete window[CALLBACK_NAME];
            reject(new Error('Failed to load the Google Maps JavaScript API'));
        };
        document.head.appendChild(script);
    });
    return pendingPromise;
}
//# sourceMappingURL=googleMapsLoader.js.map